import type { BillingModuleId } from "./module-billing.service";

export type ModuleVariantDef = {
  id: BillingModuleId;
  name: string;
  description: string;
  monthlyPrice: number;
};

export type ModuleGroupDef = {
  id: string;
  name: string;
  description: string;
  variants: ModuleVariantDef[];
};

export const MODULE_GROUPS: ModuleGroupDef[] = [
  {
    id: "products_sales",
    name: "Cadastro de produtos e vendas",
    description: "Controle de catálogo e vendas.",
    variants: [
      {
        id: "products_sales_basic",
        name: "Básico",
        description: "Até 100 produtos e vendas ilimitadas.",
        monthlyPrice: 0,
      },
      {
        id: "products_sales_advanced",
        name: "Avançado",
        description: "Até 5.000 produtos e vendas ilimitadas.",
        monthlyPrice: 19.9,
      },
      {
        id: "products_sales_unlimited",
        name: "Ilimitado",
        description: "Produtos e vendas ilimitadas.",
        monthlyPrice: 49.9,
      },
    ],
  },
  {
    id: "inventory_control",
    name: "Controle de estoque",
    description: "Plano único.",
    variants: [
      {
        id: "inventory_control",
        name: "Plano único",
        description: "Gestão de estoque completa.",
        monthlyPrice: 19.9,
      },
    ],
  },
  {
    id: "accounts_payable",
    name: "Contas a pagar",
    description: "Plano único.",
    variants: [
      {
        id: "accounts_payable",
        name: "Plano único",
        description: "Gestão de contas e vencimentos.",
        monthlyPrice: 9.9,
      },
    ],
  },
  {
    id: "customers_credit",
    name: "Clientes e Fiado",
    description: "Cadastro de clientes, saldo devedor e pagamentos.",
    variants: [
      {
        id: "customers_credit_basic",
        name: "Básico",
        description: "Até 5 clientes.",
        monthlyPrice: 0,
      },
      {
        id: "customers_credit_advanced",
        name: "Avançado",
        description: "Até 500 clientes.",
        monthlyPrice: 29.9,
      },
      {
        id: "customers_credit_unlimited",
        name: "Ilimitado",
        description: "Clientes ilimitados.",
        monthlyPrice: 49.9,
      },
    ],
  },
  {
    id: "bulk_register",
    name: "Cadastro em massa",
    description: "Plano único",
    variants: [
      {
        id: "bulk_register",
        name: "Plano único",
        description: "Inclui recursos de cadastro em massa.",
        monthlyPrice: 19.9,
      },
    ],
  },
  {
    id: "users_control",
    name: "Controle de usuário",
    description: "Acesso e limites de usuários.",
    variants: [
      {
        id: "users_basic",
        name: "Básico",
        description: "Até 3 usuários.",
        monthlyPrice: 0,
      },
      {
        id: "users_advanced",
        name: "Avançado",
        description: "Até 10 usuários.",
        monthlyPrice: 19.9,
      },
      {
        id: "users_unlimited",
        name: "Ilimitado",
        description: "Usuários ilimitados.",
        monthlyPrice: 49.9,
      },
    ],
  },
  {
    id: "cash_register",
    name: "Controle de Caixa",
    description: "Plano único gratuito.",
    variants: [
      {
        id: "cash_register",
        name: "Plano único",
        description: "Controle de abertura e fechamento de caixa.",
        monthlyPrice: 0,
      },
    ],
  },
  {
    id: "supplier_categories",
    name: "Fornecedores e Categorias",
    description: "Plano único gratuito.",
    variants: [
      {
        id: "supplier_categories",
        name: "Plano único",
        description: "Cadastro de fornecedores e categorias.",
        monthlyPrice: 0,
      },
    ],
  },
  {
    id: "statistics_reports",
    name: "Estatísticas e Relatórios",
    description: "Plano único gratuito.",
    variants: [
      {
        id: "statistics_reports",
        name: "Plano único",
        description: "Relatórios e indicadores da operação.",
        monthlyPrice: 0,
      },
    ],
  },
  {
    id: "commissions",
    name: "Comissões",
    description: "Plano único.",
    variants: [
      {
        id: "commissions",
        name: "Plano único",
        description: "Gestão de regras de comissão.",
        monthlyPrice: 19.9,
      },
    ],
  },
];

export const ALL_BILLING_MODULE_IDS: BillingModuleId[] = MODULE_GROUPS.flatMap((group) =>
  group.variants.map((variant) => variant.id)
);

/** Manter alinhado com `FULL_BUNDLE_AI_CREDIT_BONUS` em `packages/functions-stripe/src/stripe/stripe-catalog.ts`. */
export const FULL_BUNDLE_AI_CREDIT_BONUS = 2500;
